export const environment = {
  production: false,
  appUrl: '/api/',
  hubUrl: '/hub',
  i18nUrl: '',
  baseUrl: '/',
  appId: 'zPMO_514_d.moudilos@clmsuk.com',
  defaultPage: 'HomePage',
  windowsAuthentication: false,
  semanticVersion: '639148821148927752'
};